import { ReactNode } from 'react';
// Import i18n configuration - this initializes i18n
import '@/lib/i18n';

/**
 * I18nProvider component
 * The actual i18n initialization happens in lib/i18n/index.ts
 * This provider just wraps children and ensures the i18n module is loaded
 */
export function I18nProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}

// Re-export everything from the i18n library for backwards compatibility
export { i18n, SUPPORTED_LANGUAGES, isRTLLanguage, getLanguageDirection } from '@/lib/i18n';
export { useLanguage, useDirection, useT, useNumberFormat, useDateFormat } from '@/lib/i18n/hooks';
